import { render, staticRenderFns } from "./TeachersFaq.vue?vue&type=template&id=48067bda&scoped=true&"
import script from "./TeachersFaq.vue?vue&type=script&lang=ts&"
export * from "./TeachersFaq.vue?vue&type=script&lang=ts&"
import style0 from "./TeachersFaq.vue?vue&type=style&index=0&id=48067bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48067bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('48067bda', component.options)
    } else {
      api.reload('48067bda', component.options)
    }
    module.hot.accept("./TeachersFaq.vue?vue&type=template&id=48067bda&scoped=true&", function () {
      api.rerender('48067bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/classrooms/components/landing/TeachersFaq.vue"
export default component.exports